import { render, staticRenderFns } from "./BrandsHighlight.vue?vue&type=template&id=870693ba&scoped=true"
import script from "./BrandsHighlight.vue?vue&type=script&lang=js"
export * from "./BrandsHighlight.vue?vue&type=script&lang=js"
import style0 from "./BrandsHighlight.vue?vue&type=style&index=0&id=870693ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870693ba",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BrandsHighlight.vue
// module id = 228
// module chunks = 0